var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"tag":"li","to":{ name: _vm.params.routeName }}},[_c('a',[_c('i',{staticClass:"fa",class:_vm.params.icon}),_c('span',[_vm._v(_vm._s(_vm.params.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }